// Archivo: components/PrivacyPolicyPage.js
import { privacyPolicyContent } from "../data/Privacy";
import { motion } from "framer-motion";
import { FaLock, FaUserShield, FaCookie, FaShieldAlt } from "react-icons/fa"; // Puedes agregar más íconos si es necesario.

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-container bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen py-10">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        <header className="bg-navy-900 text-white py-6 px-8">
          <h1 className="text-4xl font-bold text-center">Privacy Policy</h1>
        </header>
        <main className="p-8">
          {privacyPolicyContent.map((section, index) => (
            <motion.section
              key={index}
              className="mb-8"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <div className="flex items-center mb-3">
                {index === 0 ? (
                  <FaLock className="text-navy-900 mr-2 text-1xl" />
                ) : index === 1 ? (
                  <FaUserShield className="text-navy-900 mr-2 text-1xl" />
                ) : index === 2 ? (
                  <FaCookie className="text-navy-900 mr-2 text-1xl" />
                ) : (
                  <FaShieldAlt className="text-navy-900 mr-2 text-1xl" />
                )}
                <h2 className="text-1xl font-semibold text-navy-900">{section.title}</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{section.content}</p>
            </motion.section>
          ))}
        </main>
        <footer className="bg-gray-50 border-t border-gray-200 py-4 px-8">
          <p className="text-center text-sm text-gray-600">
            © {new Date().getFullYear()} PixelCraft by Nine Star United,SRL. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
